import { msTimestampFormat } from "@/utils"
export const LogColumns = [
    {
        title: "操作名称",
        dataIndex: "operate",
        key: "operate"
    },
    {
        title: "操作人",
        dataIndex: "operator",
        key: "operator",
        scopedSlots: { customRender: "user_content" }
    },
    {
        title: "操作时间",
        dataIndex: "operate_time",
        key: "operate_time",
        customRender: (text: number) => {
            return text ? msTimestampFormat(text) : "-"
        }
    },
    {
        title: "操作详情",
        dataIndex: "operate_content",
        key: "operate_content",
        ellipsis: true,
        scopedSlots: { customRender: "change_content" }
    }
]
export const getHistoryColumns = (context: any) => {
    return [
        {
            title: "版本号",
            dataIndex: "version",
            key: "version"
        },
        {
            title: "状态",
            dataIndex: "status",
            key: "status",
            customRender: (text: number) => {
                return context.PolicyStatusMap[text] || "-"
            }
        },
        {
            title: "经办人",
            dataIndex: "director",
            key: "director",
            scopedSlots: { customRender: "director" }
        },
        {
            title: "申请日期",
            dataIndex: "apply_time",
            key: "apply_time",
            filterDropdown: true,
            customRender: (text: number) => {
                return text ? msTimestampFormat(text) : "-"
            }
        },
        {
            title: "部署时间",
            dataIndex: "deploy_time",
            key: "deploy_time",
            filterDropdown: true,
            customRender: (text: number) => {
                return text ? msTimestampFormat(text) : "-"
            }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ]
}

const plugins = "link lists table image insertdatetime formatpainter code customlink"

const toolbar =
    "removeformat formatpainter | bold italic underline strikethrough code | fontselect | fontsizeselect | formatselect | forecolor backcolor lineheight | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | table customlink unlink image"
const fontFormats =
    "SF Pro Display=SF Pro Display" +
    "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;" +
    "苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;" +
    "宋体=SimSun,simsun,serif;" +
    "黑体=SimHei,黑体,Microsoft YaHei;" +
    "微软正黑体=Microsoft JhengHei,微软正黑体;" +
    "楷体=KaiTi,楷体,楷体_GB2312,SimKai;" +
    "新宋体=NSimSun,新宋体;" +
    "仿宋=FangSong,仿宋;" +
    "隶书=SimLi,隶书;" +
    "幼圆=YouYuan,幼圆;" +
    "Arial=arial,helvetica,sans-serif;" +
    "Arial Black=arial black,avant garde;" +
    "Book Antiqua=book antiqua,palatino;" +
    "Comic Sans MS=comic sans ms,sans-serif;" +
    "Courier New=courier new,courier;" +
    "Georgia=georgia,palatino;" +
    "Helvetica=helvetica;" +
    "Impact=impact,chicago;" +
    "Symbol=symbol;" +
    "Tahoma=tahoma,arial,helvetica,sans-serif;" +
    "Terminal=terminal,monaco;" +
    "Times New Roman=times new roman,times;" +
    "Trebuchet MS=trebuchet ms,geneva;" +
    "Verdana=verdana,geneva;" +
    "Webdings=webdings;" +
    "Wingdings=wingdings,zapf dingbats"

export const InitConfig = {
    apiKey: "",
    width: "auto",
    base_url: "https://static.intsig.net/web_basic_front/tinymce",
    language_url: "https://static.intsig.net/web_basic_front/tinymce/langs/zh_CN.js",
    language: "zh_CN",
    toolbar: toolbar,
    plugins: plugins,
    paste_data_images: false,
    file_picker_types: "media",
    default_link_target: "_blank",
    menubar: "",
    statusbar: false,
    content_style: "body { font-family:SF Pro Display,Helvetica,Arial,sans-serif; font-size:14px }",
    content_css: "https://static.intsig.net/web_basic_front/tinymce/skins/ui/oxide/other.css",
    skin_url: "https://static.intsig.net/web_basic_front/tinymce/skins/ui/oxide",
    min_height: "100%",
    autoresize_bottom_margin: 0,
    font_formats: fontFormats,
    branding: false,
    fontsize_formats: "12px 14px 16px 18px 24px 32px 34px 36px 48px",
    color_formats: ["#880000", "#666666", "#000000", "#ffffff", "#0000FF"]
}
